import './style.scss';

const Loader = ({ progress }) => {
  return (
    <div className="loader-wrapper">
      <span className="loader"></span>
      {progress !== undefined && <span className="progress">{progress}%</span>}
    </div>
  );
};

export default Loader;
